import api from "../../api";

class Pedidos {
  index() {
   return api.get('pedidos');
  }

  store(data) {
    return api.post('pedidos', data);
  }

  show(id) {
    return api.get(`pedidos/${id}`);
  }

  update(id, data) {
    return api.put(`pedidos/${id}`, data);
  }

  destroy(id) {
    return api.delete(`pedidos/${id}`);
  }

  listOrders(month, year, services) {
    return api.get(`pedidos/list/${month}/${year}/${services}`);
  }
}

export default new Pedidos();
